<p-sidebar-layout class="h-screen! bg-page">
    @if (isMobile()) {
        <p-sidebar-backdrop />
    }

    <p-sidebar
        id="app-nav"
        [collapsible]="isMobile() ? 'offcanvas' : 'icon'"
        [overlay]="isMobile()"
        variant="floating"
        [(open)]="navOpen"
        [width]="'16rem'">
        <p-sidebar-spacer />
        <p-sidebar-aside>
            <p-sidebar-panel>
                <!-- Brand / org -->
                <p-sidebar-header>
                    <p-sidebar-menu>
                        <p-sidebar-menu-item>
                            <button pSidebarMenuButton class="p-2!" (click)="organisationMenu.toggle($event)">
                                <div
                                    class="flex size-7 shrink-0 items-center justify-center rounded-sm bg-logo text-white leading-none">
                                    <img src="/images/fb-icon.png" alt="" />
                                </div>
                                <span class="font-display font-bold text-md text-text truncate">{{ currentOrganization() }}</span>
                                <i class="ph ph-caret-up-down ml-auto text-text-muted"></i>
                            </button>
                            <p-menu #organisationMenu [model]="availableOrgs()" [popup]="true" appendTo="body">
                                <ng-template #item let-item>
                                    <section
                                        class="cursor-pointer flex items-center p-2 gap-3 rounded-sm hover:bg-surface-2"
                                        (click)="selectOrganization(item._id); organisationMenu.hide()">
                                        <div
                                            class="flex size-7 shrink-0 items-center justify-center rounded-sm bg-logo text-white leading-none">
                                            <img src="/images/fb-icon.png" alt="" />
                                        </div>
                                        <span class="flex-1 truncate">{{ item.name }}</span>
                                        @if (item._id === currentOrgId()) {
                                            <i class="ph ph-check text-brand"></i>
                                        }
                                    </section>
                                </ng-template>
                            </p-menu>
                        </p-sidebar-menu-item>
                    </p-sidebar-menu>
                </p-sidebar-header>

                <!-- Navigation -->
                <p-sidebar-content>
                    <p-sidebar-group>
                        <p-sidebar-group-content>
                            <p-sidebar-menu>
                                @for (item of visibleItems(); track item.key) {
                                    @if (item.items?.length) {
                                        <!-- Collapsible group; on the collapsed rail a click also opens the sidebar. -->
                                        <p-sidebar-menu-item [collapsible]="true" [defaultOpen]="hasActiveChild(item)">
                                            <button pSidebarMenuButton type="button" (click)="openForSubmenu()">
                                                <i [class]="'ph ' + item.icon"></i>
                                                <span>{{ item.label | translate }}</span>
                                            </button>
                                            <p-sidebar-menu-sub>
                                                @for (child of item.items!; track child.key) {
                                                    <p-sidebar-menu-sub-item>
                                                        <a
                                                            pSidebarMenuSubButton
                                                            [routerLink]="child.route"
                                                            routerLinkActive
                                                            #crla="routerLinkActive"
                                                            [routerLinkActiveOptions]="{ exact: !!child.exact }"
                                                            [isActive]="crla.isActive"
                                                            (click)="onNavigate()">
                                                            <i [class]="'ph ' + child.icon"></i>
                                                            <span>{{ child.label | translate }}</span>
                                                        </a>
                                                    </p-sidebar-menu-sub-item>
                                                }
                                            </p-sidebar-menu-sub>
                                        </p-sidebar-menu-item>
                                    } @else {
                                        <p-sidebar-menu-item>
                                            <a
                                                pSidebarMenuButton
                                                [routerLink]="item.route"
                                                routerLinkActive
                                                #rla="routerLinkActive"
                                                [routerLinkActiveOptions]="{ exact: !!item.exact }"
                                                [isActive]="rla.isActive"
                                                (click)="onNavigate()">
                                                <i [class]="'ph ' + item.icon"></i>
                                                <span>{{ item.label | translate }}</span>
                                            </a>
                                        </p-sidebar-menu-item>
                                    }
                                }
                            </p-sidebar-menu>
                        </p-sidebar-group-content>
                    </p-sidebar-group>
                </p-sidebar-content>

                <!-- Footer: theme toggle + user -->
                <p-sidebar-footer>
                    <p-sidebar-menu>
                        @if (!isMobile()) {
                            <p-sidebar-menu-item>
                                <button pSidebarMenuButton type="button" (click)="navOpen.update((n) => !n)">
                                    <i [class]="navOpen() ? 'ph ph-arrow-line-left' : 'ph ph-arrow-line-right'"></i>
                                    <span>{{ (navOpen() ? 'COLLAPSE_MENU' : 'EXPAND_MENU') | translate }}</span>
                                </button>
                            </p-sidebar-menu-item>
                        }
                        <p-sidebar-menu-item>
                            <button pSidebarMenuButton type="button" (click)="toggleTheme()">
                                <i [class]="mode() === 'dark' ? 'ph ph-sun' : 'ph ph-moon'"></i>
                                <span>{{ themeLabel() | translate }}</span>
                            </button>
                        </p-sidebar-menu-item>
                    </p-sidebar-menu>
                </p-sidebar-footer>

                <button pSidebarRail></button>
            </p-sidebar-panel>
        </p-sidebar-aside>
    </p-sidebar>

    <!-- Main -->
    <p-sidebar-main class="bg-page w-full">
        <header class="h-10 mx-3 mt-3 bg-surface rounded-md flex items-center gap-2 px-3 shrink-0 border border-border">
            <button
                type="button"
                pSidebarTrigger
                target="app-nav"
                class="size-8 flex items-center justify-center rounded-sm text-text hover:bg-surface-2 transition-colors duration-fast">
                <i class="ph ph-sidebar-simple cursor-pointer text-lg"></i>
            </button>
            <span class="h-5 w-px bg-border"></span>
            <span class="text-sm font-medium text-text-muted truncate">{{ currentOrganization() }}</span>
            @if (calendarMenu().length) {
                <button
                    type="button"
                    class="ml-auto h-8 px-2.5 flex items-center gap-1.5 rounded-sm text-sm text-text-2 hover:text-text hover:bg-surface-2 transition-colors"
                    aria-haspopup="menu"
                    (click)="calendarMenuRef.toggle($event)">
                    <i class="ph ph-calendar-blank text-base"></i>
                    <span class="hidden sm:inline">{{ 'CALENDARS' | translate }}</span>
                    <i class="ph ph-caret-down text-xs"></i>
                </button>
                <p-menu #calendarMenuRef [model]="calendarMenu()" [popup]="true" appendTo="body" />
            }
        </header>

        <section class="flex-1 w-full p-3 bg-page flex flex-col overflow-hidden">
            <div
                [ngClass]="isDispatch() ? 'p-0!' : ''"
                class="w-full flex-1 rounded-lg bg-surface-sunk border border-border flex flex-col overflow-y-auto p-8 [scrollbar-width:thin] [scrollbar-color:var(--th-border-strong)_transparent]">
                <router-outlet></router-outlet>
            </div>
        </section>
    </p-sidebar-main>
</p-sidebar-layout>
